import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/manager/employee/login',
    method: 'post',
    data: {
        username,
        password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

// 获取登录者所有权限
export function getUserMenu() {
    return request({
        url: '/manager/context/resource',
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js